import { Tabs } from "antd";
import type { FC } from "react";

import { canAccess } from "../../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../../core/router/config/ResourceName";

export interface DiffComponentProps {
    value?: Record<string, string>;
}

export const DiffComponent: FC<DiffComponentProps> = ({ value }) => {
    return (
        <Tabs>
            {value &&
                Object.entries(value)
                    .filter(([key]) => canAccess(ResourceName.TERMINAL_VERSIONS, key))
                    .map(([key, diffValue]) => (
                        <Tabs.TabPane tab={key} key={key}>
                            {/* eslint-disable-next-line react/no-danger */}
                            <div dangerouslySetInnerHTML={{ __html: diffValue }} />
                        </Tabs.TabPane>
                    ))}
        </Tabs>
    );
};
